export default __webpack_public_path__ + "static/media/candle-logo.b270a3d9.svg";